<template>
  <div :class="index === -1 ? 'nav-header' : 'nav-header other'">
    <div class="header-container body-container">
      <div>
        <h1 @click="gotoHome()">
          <img src="../assets/img/logo.png" alt="">
        </h1>
      </div>
      <div class="nav">
        <a href="javascript:;"
          :class="i === index ? 'active' : ''"
          v-for="(item, i) in dert"
          :key="i"
          @click="handlerClick(item,i)">{{value === '2' ? item.nameENG : item.name}}</a>
      </div>
      <el-select @change="selectChange" v-model="value" placeholder="请选择">
        <i slot="prefix" class="ali-icon-global"></i>
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navHeader',
  data () {
    return {
      dert: [
        {
          name: '关于Mafco',
          nameENG: 'About Mafco',
          url: '/about'
        }, {
          name: '专利资质',
          nameENG: 'Quality Certifications',
          url: '/certifications'
        }, {
          name: '产品目录',
          nameENG: 'Product Line',
          url: '/productLine'
        },
        {
          name: '联系我们',
          nameENG: 'Contact Us',
          url: '/contactUs'
        }
      ],
      index: 0,
      options: [
        {
          label: '中文',
          value: '1'
        },
        {
          label: 'ENG',
          value: '2'
        }
      ],
      value: sessionStorage.getItem('language') || '1'
    }
  },
  created () {
    this.init()
  },
  watch: {
    $route () {
      this.init()
      window.scrollTo(0, 0)
    }
  },
  computed: {
    language () {
      return this.$store.state.language || '1'
    }
  },
  methods: {
    init () {
      this.index = this.dert.findIndex(item => item.url === this.$route.path)
      this.index = this.$route.name === 'customers' ? 10 : this.index
      // this.index = this.index === -1 ? 0 : this.index
    },
    /**
     * @toto 导航点击
     */
    handlerClick (item, index) {
      if (this.index !== index) {
        this.index = index
        // if (item.url) this.$router.push(item.url)
        this.$emit('menuChanged', item.url)
      }
    },
    gotoHome () {
      if (this.index !== -1) {
        this.index = -1
        this.$emit('menuChanged', '/')
      }
    },
    // 语言切换
    selectChange () {
      sessionStorage.setItem('language', this.value)
      this.$store.commit('languageChange', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/font.scss';
@import '@/style/default.scss';

.nav-header {
  height: 88px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: transparent;
  z-index: 99;
  -webkit-transition-property: background-color;
  -webkit-transition-duration: 0.3s;
  -webkit-transition-timing-function: ease;
  &:hover {
    background: rgba(0, 104, 56, 1);
  }

  .header-container {
    height: 100%;
    display: flex;
    align-items: center;

    h1 {
      // width: 128px;
      // height: 48px;
      // background: #ccc;
      height: 88px;
      font-size: 18px;
      font-weight: normal;
      margin: 0;
      cursor: pointer;

      img {
        height: 100%;
      }
    }

    p {
      font-family: $Microsoft-YaHei;
      font-size: 12px;
      color: $about-color;
    }

    .nav {
      flex: 1;
      text-align: right;
      height: 100%;
      line-height: 88px;

      a {
        font-size: 18px;
        margin-left: 30px;
        display: inline-block;
        color: rgba(255, 255, 255, 0.9);
        display: inline-block;
        min-width: 80px;
        text-align: center;
        padding: 0;
        -webkit-transition-property: font-color;
        -webkit-transition-property: font-weight;
        -webkit-transition-duration: 0.2s;
        -webkit-transition-timing-function: ease;
        height: 84px;
        &:hover {
          color: #fff;
          border-bottom: 4px solid #fff;
          font-weight: bold;
        }
        &:active {
          color: $about-color;
        }
      }

      .active {
        color: #fff;
        // border-bottom: 4px solid #fff;
        font-weight: bold;
      }
    }
  }
}
.nav-header.other {
  background-color: rgba(0, 104, 56, 1);
}

::v-deep .el-select {
  width: 95px;
  margin-left: 80px;
  &:hover {
    .el-input__inner, .el-input__prefix i {
      font-weight: bold;
      color: rgba(255,255,255,1);
    }
  }
  .el-input__inner {
    text-align: right;
    border: 0;
    background-color: transparent;
    color: rgba(255,255,255,0.8);
    font-size: 16px;
  }
  .el-input__prefix i {
    line-height: 42px;
    font-size: 20px;
    color: rgba(255,255,255,0.8);
  }
}
</style>
